import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Collapse,
  IconButton,
  Typography,
  Grid,
  TextField,
  Box
} from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const BannerStatements = ({
  formData,
  handleChange,
  expanded,
  toggleSection
}) => {
  return (
    <Card
      elevation={3}
      sx={{
        mb: 3,
        borderLeft: '6px solid #9c27b0',
        borderRadius: 2,
        backgroundColor: '#fafafa'
      }}
    >
      <CardHeader
        avatar={<FormatQuoteIcon sx={{ color: '#9c27b0' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#000' }}>
            Banner Statements
          </Typography>
        }
        action={
          <IconButton onClick={() => toggleSection('bannerStatements')}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        sx={{
          backgroundColor: '#f0f0f5',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          py: 1.5,
          px: 2
        }}
      />
      <Divider />
      <Collapse in={expanded}>
        <CardContent sx={{ px: 3, py: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Above Banner Statement"
                name="above_banner_statement"
                value={formData.above_banner_statement}
                onChange={handleChange}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText="Displayed above the banner image"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': {
                      borderColor: '#ce93d8',
                    },
                    '&:hover fieldset': {
                      borderColor: '#ab47bc',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#9c27b0',
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Below Banner Statement"
                name="below_banner_statement"
                value={formData.below_banner_statement}
                onChange={handleChange}
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                helperText="Displayed below the banner image"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    '& fieldset': {
                      borderColor: '#ce93d8',
                    },
                    '&:hover fieldset': {
                      borderColor: '#ab47bc',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#9c27b0',
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default BannerStatements;
